import httpClient from './httpClient'

export default {

    // 物件一覧取得
    async getList(options, page, tabName) {

        return httpClient.get('/devereach/search', {
            params: {
                newly_from: options.newlyFrom,
                newly_to: options.newlyTo,
                price_from: options.price_from,
                price_to: options.price_to,
                land_area_from: options.land_area_from,
                land_area_to: options.land_area_to,
                unit_price_from: options.unit_price_from,
                unit_price_to: options.unit_price_to,
                area: options.area,
                station_distance: options.station_distance,
                floor_area_ratio_from: options.floor_area_ratio_from,
                floor_area_ratio_to: options.floor_area_ratio_to,
                limit: options.limit,
                page: page,
                tab_name: tabName,
                only_favorite: options.only_favorite
            }})
        .then(response => response.data || response)
        .catch(error => error.response || error)
    },

    async getDetail(id) {
        return httpClient.get(`/devereach/property/${id}`)
            .then(response => response.data || response)
            .catch(error => error.response || error)
    },

    // 物件情報の更新
    async update(property) {
        return httpClient.post(`/devereach/admin/property/update`, property)
            .then(response => response)
            .catch(error => error.response || error)
    },

    // 物件の詳細情報を取得（文字列なども含む全てのデータ）
    async getDetailWithStr(id) {
        return httpClient.get(`/devereach/admin/property/${id}`)
            .then(response => response.data || response)
            .catch(error => error.response || error)
    },

    // 掲載ステータスの変更
    async changePublicStatus(property) {
        const params = {
            id: property.id,
            is_public: property.is_public
        }

        return httpClient.post('/devereach/property/change', params)
            .then(response => response)
            .catch(error => error.response || error)
    },

    // お気に入り登録
    async favorite(property) {
        return httpClient.post(`/devereach/property/${property.id}/favorite`)
            .then(response => response)
            .catch(error => error.response || error)
    },

    // お気に入り解除
    async unfavorite(property) {
        return httpClient.delete(`/devereach/property/${property.id}/favorite`)
            .then(response => response)
            .catch(error => error.response || error)
    }
}